/**
 * Created by zack on 2018/1/25.
 */
import AES from 'crypto-js/aes'
import MD5 from 'crypto-js/md5'
import CryptoJS from 'crypto-js'

const AESKey = {
	default: '123!MDLand->20i7~',
    vitalSign: '!MDLand->20i7~',
	account: '!MDLand->20i9~',
	loginResponse: '!MDLand->2~0i9~',
	content: '!MDLand->2~0i9!!~',
	log: 'MDLand_log'
};

const AESTool = {
	encrypt(text, key) {
		let encrypt_key = key || AESKey.default;
		return AES.encrypt(text, encrypt_key).toString()
	},
	decrypt(text, key) {
        let encrypt_key = key || AESKey.default;
        let bytes  = AES.decrypt(text, encrypt_key);
		return  bytes.toString(CryptoJS.enc.Utf8)
	}
};

const MD5Tool = {
	encrypt(text) {
		return MD5(text).toString()
	}
};

export {
	AESKey,
	AESTool,
	MD5Tool
}
